<template>
<div class="discountinfo" v-if="visible">
  <div class="discountinfo_main">
    <div class="discountinfo_header">
      优惠明细
      <i class="header_close el-icon el-icon-close" @click="close" ></i>
    </div>
    <div class="discountinfo_body">
      <!-- {{promotionDetail}} -->
      <template>
        <!-- {{'promotionDetail' + promotion}} -->
        <section class="item order-item" v-for="(item, index) in promotionDetail" :key="index" :ref="'item'+index">
          <header class="item_header">
            <div class="discountinfo_body_left left title">{{item.title}}</div>
            <div class="discountinfo_body_right right">
              <span class="price title-price">- ¥{{item.price}}</span>
              <i class="el-icon-arrow-down" @click="openCourse(item, index, 'item')" :ref="'item-arrow'+index"></i>
            </div>
          </header>
          <div v-if="item.detail.length > 0">
            <div class="discountinfo_body_info" v-for="(detail, num) in item.detail" :key="num" :ref="index + '_detail' + num" :class="index + '_detail' + num">
              <section class="info_header">
                <div class="discountinfo_body_left left">{{detail.name}}</div>
                <div class="discountinfo_body_right right">
                  <span class="price">-¥{{detail.price}}</span><i class="el-icon-arrow-down" @click="openCourse(item, num, index + '_detail')" :ref="index + '_detail-arrow'+num"></i>
                </div>
              </section>
              <section class="info_item" v-for="(product, m) in detail.detail" :key="m">
                <div class="left">
                  <span class="subject">{{product.subjectName}}</span>
                  <span>{{product.productName}}</span>
                </div>
                <div class="right">
                  <span class="price">-¥{{product.price}}</span>
                </div>
              </section>
            </div>
          </div>
        </section>
        <!-- 金币 -->
        <section class="item order-item" v-if="gold">
          <header class="item_header">
            <div class="discountinfo_body_left left title">金币</div>
            <div class="discountinfo_body_right right">
              <span class="price title-price">- ¥{{gold}}</span>
            </div>
          </header>
        </section>
        <!-- 礼品卡 -->
        <!-- <section class="item order-item" v-if="gift">
          <header class="item_header">
            <div class="discountinfo_body_left left title">礼品卡抵扣</div>
            <div class="discountinfo_body_right right">
              <span class="price title-price">- ¥{{gift}}</span>
            </div>
          </header>
        </section> -->
      </template>
    </div>
    <div class="discountinfo_btn" @click="close">好的</div>
  </div>
</div>
</template>
<script>
export default {
  props: ['visible', 'promotionDetail', 'gift', 'gold'],
  methods: {
    close () {
      this.$emit('update:visible', false)
    },
    openCourse (item, index, name) {
      let resName = name + index
      let arowName = `${name}-arrow${index}`
      // console.log(resName, arowName)
      let el = this.$refs[resName][0]
      let arow = this.$refs[arowName][0]
      if (arow.className === 'el-icon-arrow-down') {
        el.style.height = 'auto'
        arow.classList.remove('el-icon-arrow-down')
        arow.classList.add('el-icon-arrow-up')
      } else {
        el.style.height = '18px'
        arow.classList.remove('el-icon-arrow-up')
        arow.classList.add('el-icon-arrow-down')
      }
      // if (!item.open) {
      //   el.style.height = '17px'
      //   arow.classList.remove('el-icon-arrow-up')
      //   arow.classList.add('el-icon-arrow-down')
      // } else {
      //   el.style.height = 'auto'
      //   arow.classList.remove('el-icon-arrow-down')
      //   arow.classList.add('el-icon-arrow-up')
      // }
    },
    openCourse2 ($event) {
      console.log($event)
    }
  }
}
</script>
<style lang="less" scoped>
.discountinfo{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background:rgba(0,0,0,0.7);
  z-index: 2002;
  &_main{
    position: relative;
    margin: 0 auto 50px;
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    width: 664px;
    padding-bottom: 23px;
    margin-top: 15vh;
  }
  &_header{
    height:50px;
    background:rgba(245,245,245,1);
    font-size:16px;
    color:rgba(0,0,0,1);
    line-height: 50px;
    text-align: center;
    margin-bottom: 56px;
    .header_close {
      position: absolute;
      top: 16px;
      right:20px;
      color: #999999;
    }
  }
  &_body{
    width: 616px;
    height: 340px;
    border: 1px solid rgba(220,220,220,1);
    margin: 0 auto;
    box-sizing: border-box;
    padding: 20px 16px;
    overflow-y: auto;
    line-height: 16px;
    // .open{
    //   height: auto !important;
    // }
    .item {
      color: #3E3E3E;
      height: 16px;
      overflow: hidden;
      .title{
        font-size:14px;
        color:rgba(33,40,49,1);
        height: 18px;
        font-weight: 600;
      }
    }
    .title-price{
      font-size: 14px;
    }
    .item_header{
      height: 18px;
      margin-bottom: 20px;
    }
    .info_header {
      height: 18px;
    }
    .order-item {
      margin-bottom: 30px;
    }
    .info_item{
      // height: 14px;
      overflow: hidden;
      font-size: 14px;
      // margin: 10px 0;
      color: #5B6069;
      border-bottom: 1px solid #DCDCDC;
      padding-bottom: 12px;
      width: 100%;
      margin-top: 17px;
      .subject{
        display: inline-block;
        // padding: 2px 3px;
        border: 1px solid rgba(235,0,42,1);
        color: #EB002A;
        transform: scale(.7);
        border-radius: 2px;
        text-align: center;
        line-height: 14px;
        padding: 1px 2px;
      }
    }
    &_info{
      padding-left: 20px;
      height: 16px;
      font-size:14px;
      margin-bottom: 20px;
      overflow: hidden;
    }
    .title-price{
      color: #F13232;
    }
    // .price{
    //   margin-right: 4px;
    // }
  }
  &_btn{
    width:160px;
    height:41px;
    background:rgba(241,50,50,1);
    border-radius:2px;
    text-align: center;
    color: #fff;
    line-height: 41px;
    margin: 0 auto;
    margin-top: 24px;
  }
  .left{
    float: left;
  }
  .right{
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// module/order/src/components/sub/Discount.vue